__turbopack_context__.v({
  "arrow": "Nxun2a_arrow",
  "chevron": "Nxun2a_chevron",
  "divider": "Nxun2a_divider",
  "dropdown": "Nxun2a_dropdown",
  "footer": "Nxun2a_footer",
  "item": "Nxun2a_item",
  "itemDescription": "Nxun2a_itemDescription",
  "itemIndicator": "Nxun2a_itemIndicator",
  "itemLabel": "Nxun2a_itemLabel",
  "itemSection": "Nxun2a_itemSection",
  "itemTitle": "Nxun2a_itemTitle",
  "items": "Nxun2a_items",
  "label": "Nxun2a_label",
  "overlay": "Nxun2a_overlay",
});
